/* eslint-disable prettier/prettier */
export const GET_BOOKINGS = "GET_BOOKINGS";
export const IS_LOADING_BOOKINGS = "IS_LOADING_BOOKINGS";
export const GET_CURRENT_BOOKING = "GET_CURRENT_BOOKING";
export const GET_CURRENT_BOOKING_CANDIDATES = "GET_CURRENT_BOOKING_CANDIDATES";
export const GET_CURRENT_BOOKING_COMMENTS = "GET_CURRENT_BOOKING_COMMENTS";
export const GET_CURRENT_BOOKING_PUBLISHING_SCHEDULE = "GET_CURRENT_BOOKING_PUBLISHING_SCHEDULE";
export const IS_LOADING_BOOKING = "IS_LOADING_BOOKING";
export const IS_LOADING_BOOKING_CANDIDATES = "IS_LOADING_BOOKING_CANDIDATES";
export const IS_LOADING_BOOKING_COMMENTS = "IS_LOADING_BOOKING_COMMENTS";
export const IS_LOADING_BOOKING_PUBLISHING_SCHEDULE = "IS_LOADING_BOOKING_PUBLISHING_SCHEDULE";
export const GET_CANDIDATES_FOR_SUBMIT = "GET_CANDIDATES_FOR_SUBMIT";
export const SET_IS_FETCHING_CANDIDATES_FOR_SUBMIT = "SET_IS_FETCHING_CANDIDATES_FOR_SUBMIT";
export const GET_EVALUATION_STATUSES = "GET_EVALUATION_STATUSES";
export const GET_USERS_FOR_SHARING = "GET_USERS_FOR_SHARING";
export const IS_FETCHING_SHARING_USERS = 'IS_FETCHING_SHARING_USERS';
export const GET_BOOKING_OPTIONS = "GET_BOOKING_OPTIONS";
export const IS_FETCHING_BOOKING_OPTIONS = 'IS_FETCHING_BOOKING_OPTIONS';
export const GET_BOOKING_LIST_FILTERS = 'GET_BOOKING_LIST_FILTERS';
export const GET_PUBLISHING_CHANNELS = 'GET_PUBLISHING_CHANNELS';
export const GET_IS_FETCHING_PUBLISHING_CHANNELS = 'GET_IS_FETCHING_PUBLISHING_CHANNELS';

const bookingsGetters = {
  [GET_BOOKINGS]: state => state.bookings,
  [GET_CURRENT_BOOKING]: state => state.currentBooking,
  [GET_CURRENT_BOOKING_CANDIDATES]: state => state.currentBookingCandidates,
  [GET_CURRENT_BOOKING_COMMENTS]: state => state.bookingComments,
  [GET_CURRENT_BOOKING_PUBLISHING_SCHEDULE]: state => state.currentBookingPublishingSchedule,
  [IS_LOADING_BOOKING]: state => state.isFetchingCurrentBooking,
  [IS_LOADING_BOOKING_COMMENTS]: state => state.isFetchingBookingComments,
  [IS_LOADING_BOOKING_CANDIDATES]: state => state.isFetchingCurrentBookingCandidates,
  [IS_LOADING_BOOKING_PUBLISHING_SCHEDULE]: state => state.isFetchingBookingPublishingSchedule,
  [IS_LOADING_BOOKINGS]: state => state.isFetchingBookings,
  [GET_CANDIDATES_FOR_SUBMIT]: state => state.candidatesForSubmit,
  [SET_IS_FETCHING_CANDIDATES_FOR_SUBMIT]: state => state.isFetchingCandidatesForSubmit,
  [GET_EVALUATION_STATUSES]: state => state.evaluationStatuses,
  [GET_USERS_FOR_SHARING]: state => state.usersForSharing,
  [IS_FETCHING_SHARING_USERS]: state => state.isFetchingSharingUsers,
  [GET_BOOKING_OPTIONS]: state => state.bookingOptions,
  [IS_FETCHING_BOOKING_OPTIONS]: state => state.isFetchingBookingOptions,
  [GET_BOOKING_LIST_FILTERS]: state => state.bookingListFilters,
  [GET_PUBLISHING_CHANNELS]: state => state.publishingChannels,
  [GET_IS_FETCHING_PUBLISHING_CHANNELS]: state => state.isFetchingPublishingChannels
};

export default bookingsGetters;
